import React from 'react';
import { Moon, AlertCircle } from 'lucide-react';
export function Hook() {
  return <section className="py-16 px-4 bg-white" data-id="element-99">
      <div className="max-w-3xl mx-auto" data-id="element-100">
        <div className="bg-slate-50 border-l-4 border-slate-800 p-6 md:p-8 rounded-r-xl shadow-sm relative" data-id="element-101">
          <Moon className="absolute top-6 right-6 w-12 h-12 text-slate-200" data-id="element-102" />

          <p className="text-lg md:text-xl text-slate-700 leading-relaxed font-medium mb-6" data-id="element-103">
            <span className="font-bold text-slate-900" data-id="element-104">
              Son las 10 de la noche.
            </span>{' '}
            Acabas de bañar a tus hijos y, al pasar el cepillo, ves ese
            movimiento rápido en la nuca. El corazón se te hunde.
          </p>

          <p className="text-lg md:text-xl text-slate-700 leading-relaxed mb-6" data-id="element-105">
            Sientes asco, frustración y una fatiga inmensa porque sabes que los
            shampoos de farmacia que compraste la semana pasada volvieron a
            fallar.
          </p>

          <div className="bg-white p-5 rounded-lg border border-slate-200 flex gap-4 items-start mt-8 shadow-sm" data-id="element-106">
            <AlertCircle className="w-6 h-6 text-teal-600 flex-shrink-0 mt-1" data-id="element-107" />
            <p className="text-slate-800 font-medium" data-id="element-108">
              No es que seas una mala madre ni que tu casa esté sucia. Es que te
              han vendido soluciones incompletas que no atacan el verdadero
              problema:{' '}
              <span className="text-teal-700 font-bold underline decoration-teal-300 underline-offset-4" data-id="element-109">
                el ciclo biológico del parásito.
              </span>
            </p>
          </div>
        </div>
      </div>
    </section>;
}